import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import theme from './theme';

/**
 * ThemeProvider component to provide the theme to all styled components
 * Wrap your application with this component to make the theme available
 * 
 * Usage:
 * <ThemeProvider>
 *   <App />
 * </ThemeProvider>
 */
const ThemeProvider = ({ children }) => {
  return (
    <StyledThemeProvider theme={theme}>
      {children}
    </StyledThemeProvider>
  );
};

export default ThemeProvider;
